import React from 'react';
import clsx from 'clsx';

import Section from '@common/Section';
import Container from '@common/Container';
import RichText from '@common/RichText';
import Heading from '@common/Heading';

import * as styles from './summit-agenda.module.scss';

const SummitAgenda = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    topMargin,
    bottomMargin,
    bgColour
  } = data;
  return (
    <Section spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx(styles.topPadding, {[`bg-${bgColour} pb-7`]: bgColour})}>
      <Container className='ps-lg-5'>
        {(showTitle && title) &&
          <Heading type='h1' className={clsx('ps-1 mb-3 fs-24 fw-medium text-uppercase', styles.titleAgenda)}>{title}</Heading>
        }
        {text &&
          <div className='col-lg-9'>
            <RichText json={text}/>
          </div>
        }
      </Container>
    </Section>
  )
}

export default SummitAgenda
